import axios from 'axios';

import { IRequestConfig, MethodsTypes } from 'models/Axios';
import { IQuotesData, IQuotes } from 'models/Quote';
import Services from './index.service';

export default class BCGSevices extends Services<IQuotesData, IQuotes> {
  /**
   * Function to get a limited qtd of items
   * @currentPage Range to skip, you need only pass currentPage (ex: currentPage = 1)
   * @pageSize Range to take, you need only pass pageSize (ex: pageSize = 15)
   */

  getUserByUserName = (userName: string) => {
    if (!userName) return Promise.resolve({ status: 404, data: null } as any);

    const config: IRequestConfig<any> = {
      url: `${this.mafraq_url}/UserBCG/GetUserBCG/${userName}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.access_token()}`,
      },
      method: MethodsTypes.get
    };

    return axios(config);
  };
}
